import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=1dc1d6c1&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=1dc1d6c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1d6c1",
  null
  
)

export default component.exports